export default {
  error_types: 'Имеются файлы, которые не поддерживаются. Допустимые расширения {{ types }}',
  error_size: 'Имеются файлы, которые превышают допустимый размер {{ size }}',
  total_size: 'Общий размер {{ size }}',
  clear_all: 'Очистить все',
  attach_files: 'Прикрепить файлы',
  attach_help: 'Воспользуйтесь кнопкой или перетащите файлы в эту область',
  loading: 'Подождите, загрузка {{ process }}%',
};
